module.exports = __webpack_public_path__ + "img/hot_zww.ea3eb1b9.svg";